import React from 'react';
import styled, { css } from 'styled-components';
import theme from '../theme';

const defaultProps = {
  hierarchyType: 'primary' as 'primary' | 'secondary' | 'tertiary',
  size: 'large' as 'large' | 'medium' | 'small',
  color: 'blue' as 'blue' | 'white',
  icon: 'none' as 'none' | 'left' | 'right' | 'only',
  text: '',
  iconSrc: ''
};

const ButtonStyles = styled.button<typeof defaultProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  cursor: pointer;
  text-transform: uppercase;
  ${theme.font.label.m}

  ${props =>
    (props.hierarchyType === 'primary' ||
      props.hierarchyType === 'secondary') &&
    css`
      border-radius: 3px;
    `}

  ${props =>
    (props.hierarchyType === 'primary' || props.hierarchyType === 'tertiary') &&
    css`
      border: none;
    `}

    ${props =>
      props.hierarchyType === 'primary' &&
      css`
        &:disabled {
          background-color: var(--colors-neutral-gray-2);
          color: var(--colors-neutral-gray-3);

          &:hover {
            background-color: var(--colors-neutral-gray-2);
            color: var(--colors-neutral-gray-3);
            cursor: not-allowed;
          }
        }
      `}

    ${props =>
      props.hierarchyType == 'primary' &&
      props.color === 'blue' &&
      css`
        background-color: var(--colors-primary-blue-2);
        color: var(--colors-neutral-white);

        &:hover {
          background-color: var(--colors-primary-blue-3);
          color: var(--colors-neutral-white);
        }

        &:focus {
          box-shadow: 0 0 0 2px var(--colors-primary-blue-3),
            0 0 0 1px var(--colors-neutral-white);
        }

        &:active {
          background-color: var(--colors-primary-blue-4);
          color: var(--colors-neutral-white);
        }
      `}

      ${props =>
        props.hierarchyType == 'primary' &&
        props.color === 'white' &&
        css`
          background-color: var(--colors-neutral-white);
          color: var(--colors-primary-blue-2);

          &:hover {
            background-color: var(--colors-neutral-white);
            color: var(--colors-primary-blue-3);
          }

          &:focus {
            box-shadow: 0 0 0 2px var(--colors-neutral-white),
              0 0 0 1px var(--colors-primary-blue-3);
          }

          &:active {
            background-color: var(--colors-neutral-white);
            color: var(--colors-primary-blue-4);
          }
        `}

        ${props =>
          (props.hierarchyType === 'primary' ||
            props.hierarchyType === 'secondary') &&
          props.size === 'large' &&
          css`
            padding: 20px;
          `}

          ${props =>
            (props.hierarchyType === 'primary' ||
              props.hierarchyType === 'secondary') &&
            props.size === 'medium' &&
            css`
              padding: 16px;
            `}

          ${props =>
            (props.hierarchyType === 'primary' ||
              props.hierarchyType === 'secondary') &&
            props.size === 'small' &&
            css`
              padding: 12px;
            `}

          ${props =>
            props.hierarchyType === 'secondary' &&
            css`
              border-width: 1px;
              border-style: solid;

              &:disabled {
                background-color: var(--colors-neutral-gray-2);
                color: var(--colors-neutral-white);
                border-color: var(--colors-neutral-gray-2);
                cursor: not-allowed;
                outline: none;

                &:hover,
                &:active,
                &:focus {
                  background-color: var(--colors-neutral-gray-2);
                  color: var(--colors-neutral-white);
                  border-color: var(--colors-neutral-gray-2);
                  cursor: not-allowed;
                  outline: none;
                  box-shadow: none;
                }
              }
            `}

            ${props =>
              props.hierarchyType === 'secondary' &&
              props.color === 'blue' &&
              css`
                background-color: transparent;
                color: var(--colors-primary-blue-2);
                border-color: var(--colors-primary-blue-2);

                &:hover {
                  background-color: var(--colors-primary-blue-3);
                  color: var(--colors-neutral-white);
                  border-color: var(--colors-primary-blue-3);
                }

                &:focus {
                  box-shadow: 0 0 0 2px var(--colors-primary-blue-3),
                    0 0 0 1px var(--colors-neutral-white);
                }

                &:active {
                  background-color: var(--colors-primary-blue-4);
                  color: var(--colors-neutral-white);
                  border-color: var(--colors-primary-blue-4);
                }
              `}

              ${props =>
                props.hierarchyType === 'secondary' &&
                props.color === 'white' &&
                css`
                  background-color: transparent;
                  color: var(--colors-neutral-white);
                  border-color: var(--colors-neutral-white);

                  &:hover {
                    background-color: var(--colors-neutral-white);
                    color: var(--colors-primary-blue-3);
                    border-color: var(--colors-neutral-white);
                  }

                  &:focus {
                    box-shadow: 0 0 0 2px var(--colors-neutral-white),
                      0 0 0 1px var(--colors-primary-blue-3);
                  }

                  &:active {
                    background-color: var(--colors-neutral-white);
                    color: var(--colors-primary-blue-4);
                    border-color: var(--colors-neutral-white);
                  }
                `}

                ${props =>
                  props.hierarchyType === 'tertiary' &&
                  css`
                    border: none;
                    padding: 0;
                    background-color: transparent;

                    &:disabled {
                      color: var(--colors-neutral-gray-3);
                    }
                  `}

                ${props =>
                  props.hierarchyType === 'tertiary' &&
                  props.color === 'blue' &&
                  css`
                    color: var(--colors-primary-blue-2);

                    &:hover {
                      color: var(--colors-primary-blue-3);
                    }

                    &:focus {
                      border-radius: 3px;
                      box-shadow: 0 0 0 2px var(--colors-primary-blue-3),
                        0 0 0 1px var(--colors-neutral-white);
                    }

                    &:active {
                      color: var(--colors-primary-blue-4);
                    }
                  `}

                  ${props =>
                    props.hierarchyType === 'tertiary' &&
                    props.color === 'white' &&
                    css`
                      color: var(--colors-neutral-white);

                      &:hover {
                        color: var(--colors-neutral-gray-2);
                      }

                      &:focus {
                        border-radius: 3px;
                        box-shadow: 0 0 0 2px var(--colors-neutral-white),
                          0 0 0 1px var(--colors-primary-blue-3);
                      }

                      &:active {
                        color: var(--colors-neutral-gray-3);
                      }
                    `}


`;
const ButtonTextChildrenContainer = styled.div`
  display: inline-block;
`;

const Button: React.FC<
  Omit<typeof defaultProps, 'iconSrc' | 'text'> &
    Partial<Pick<typeof defaultProps, 'iconSrc' | 'text'>> &
    React.ComponentProps<typeof ButtonStyles>
> = (props = defaultProps) => {
  return (
    <ButtonStyles {...props}>
      {props.icon === 'left' && <img src={props.iconSrc} alt="icon" />}
      {props.icon !== 'only' && (
        <ButtonTextChildrenContainer>
          {props.text || props.children}
        </ButtonTextChildrenContainer>
      )}
      {props.icon === 'right' ||
        (props.icon === 'only' && <img src={props.iconSrc} alt="icon" />)}
    </ButtonStyles>
  );
};

export default Button;
